import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6a971d3c"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryCardVertical: require('/opt/build/repo/components/category/CardVertical.vue').default,ProductCardLoading: require('/opt/build/repo/components/product/CardLoading.vue').default})
